import { makeApiCallWithAny } from "./tokenService";
import { ISalaryPeriodItem } from "../models/salaryPeriod/salaryPeriodItem";

export const getSalaryPeriods = (
    signal?: AbortSignal
): Promise<ISalaryPeriodItem[]> => {
    return makeApiCallWithAny("api/salaryperiod", signal);
};
